const initialState = {
  integracao: {
    usernametrello: '',
    useraccountidjira: ''
  },
  loading: false,
  erro: {}
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'SET_INTEGRACAO_USUARIO_PDCA':
      return {
        ...state,
        integracao: {
          ...state.integracao,
          [payload.name]: payload.value
        }
      }

    case 'SET_INTEGRACAO_USUARIO_PDCA_RESPONSE':
      return {
        ...state,
        integracao: {
          usernametrello: payload?.usernametrello || '',
          useraccountidjira: payload?.useraccountidjira || ''
        }
      }

    case 'SET_LOADING_INTEGRACAO_USUARIO_PDCA':
      return {
        ...state,
        loading: payload
      }

    case 'SET_ERRO_INTEGRACAO_USUARIO_PDCA':
      return {
        ...state,
        erro: payload
      }

    case 'CLEAN_INTEGRACAO_USUARIO_PDCA':
      return {
        ...state,
        integracao: initialState.integracao,
        loading: false,
        erro: {}
      }

    default:
      return state
  }
}